var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlgeria({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_5614)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5614",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 3H0.714111V23.0023H35V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 3H0.714111V23.0023H17.8571V3Z",
    fill: "#327539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5669 16.1184C19.8459 17.4979 17.328 17.2233 15.9419 15.4956C14.5624 13.7679 14.8436 11.2568 16.5646 9.8706C18.2856 8.49113 20.8035 8.76568 22.1897 10.4934C21.7477 9.73667 21.1182 9.1005 20.3615 8.66523C17.9709 7.28576 14.9106 8.10273 13.5311 10.4934C12.1517 12.884 12.9686 15.9443 15.3593 17.3238C17.7499 18.7032 20.8102 17.8863 22.1897 15.4956C22.0022 15.73 21.7946 15.9376 21.5669 16.1184Z",
    fill: "#C01F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5847 13.9085L20.6495 15.3751V13.5603L22.3772 12.9978L20.6495 12.4353V10.6206L19.5847 12.0871L17.8571 11.5313L18.9285 12.9978L17.8571 14.4643L19.5847 13.9085Z",
    fill: "#C01F3F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_5614",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5614"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5614",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgeria);
export default __webpack_public_path__ + "static/media/Algeria.af8bcbc5f65384a6838cf18a6682639b.svg";
export { ForwardRef as ReactComponent };